var finance = {};
module['exports'] = finance;
finance.account_type = require("./account_type");
finance.transaction_type = require("./transaction_type");
finance.currency = require("./currency");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/finance/index.js
 ** module id = 450
 ** module chunks = 0
 **/